import { useTranslation } from "@opendash/i18n";
import { Empty, Flex } from "antd";
import { observer } from "mobx-react-lite";
import React from "react";
import { ArticleCollapsable } from "../../../messages";
import { useTicketData } from "../../_shared";
import { TodoListItem } from "./TodoListItem";

type Props = {
  reload?: () => void;
};

export const TicketTodoList = observer((props: Props) => {
  const t = useTranslation();
  const { todos, ticket } = useTicketData();

  return (
    <>
      <Flex vertical gap="small">
        {(!todos || todos.length <= 0) && <Empty />}
        {todos.map((todo) => (
          <TodoListItem key={todo.id} message={todo} onUpdate={props.reload} />
        ))}
      </Flex>
      <ArticleCollapsable
        referencedObject={ticket}
        onOkUpdate={props.reload}
        showAsTodo
        showdivider
        shownewmessage
        lockTodo
        dividerLabel={t("maintenance:ticket.todos.add.title")}
      />
    </>
  );
});
